import { render, staticRenderFns } from "./WorkloadDetailTableActions.vue?vue&type=template&id=7c2ebae4&scoped=true"
import script from "./WorkloadDetailTableActions.vue?vue&type=script&lang=js"
export * from "./WorkloadDetailTableActions.vue?vue&type=script&lang=js"
import style0 from "./WorkloadDetailTableActions.vue?vue&type=style&index=0&id=7c2ebae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2ebae4",
  null
  
)

export default component.exports